/**
 * 封装 axios 请求模块
 */
import axios from 'axios'
import { getToken } from '@/utils/authManager'
import router from '@/router/index.js';

// 创建一个axios实例对象
const request = axios.create({
  baseURL: 'https://new.moqukeji.com' //
  // baseURL: 'http://moqu.com' //
})

// 配置请求拦截器
request.interceptors.request.use(
  async config => {
    let token = getToken();
    
    // 在 App 环境中，如果本地没有 Token，尝试从 JSBridge 获取
    if (!token && window.jsBridge && window.jsBridge.isInApp) {
      try {
        const userInfo = await window.jsBridge.getUserInfo();
        if (userInfo && userInfo.token) {
          token = userInfo.token;
          // 更新全局登录状态
          if (window.globalAuthState) {
            window.globalAuthState.token = token;
            window.globalAuthState.isLogin = true;
            window.globalAuthState.userId = userInfo.userId || '';
          }
        }
      } catch (error) {
        console.warn('从 JSBridge 获取 Token 失败:', error);
      }
    }
    
    // 如果 token 存在，将其添加到请求头中
    if (token) {
      config.headers.token = `${token}`;
    }
    
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    
    // 如果不需要token，删除Authorization头
    if (isToken) {
      delete config.headers.token;
    }
    
    return config;
  },
  error => {
    // 处理请求错误
    return Promise.reject(error);
  }
);

// 配置响应拦截器
request.interceptors.response.use(
  response => {
    // 将response.data直接返回，这样接口调用时就可以直接使用response而不是response.data
    if(response.data.data == 'need login') {
      // 处理未登录状态
      // 在浏览器中，跳转到登录页面
      console.log('需要登录：在浏览器中，跳转到登录页面');
      // 使用路由器实例进行跳转
      router.push('/login');
    }
    return response.data
  },
  error => {
    // 处理响应错误
    return Promise.reject(error)
  }
)

// 暴露出去
export default request